import React from "react";
import PropTypes from "prop-types";
import "react-quill-new/dist/quill.snow.css";
import { Box } from "@mui/material";
import { createSafeHtml } from "../../utils/sanitizeHtml";

const QUILL_ALLOWED = {
    ALLOWED_TAGS: [
        "h1", "h2", "h3", "h4", "h5", "h6",
        "p", "br", "hr",
        "ul", "ol", "li",
        "div", "span",
        "strong", "b", "em", "i", "u", "s", "strike",
        "blockquote", "pre", "code",
        "sub", "sup",
    ],
    ALLOWED_ATTR: ["class", "style", "data-list"],
    ALLOW_DATA_ATTR: true,
    ALLOW_UNKNOWN_PROTOCOLS: false,
};

export const DmsRichTextViewer = ({ html, maxHeight = 400, sx }) => {
    if (!html || html === "<p><br></p>") return null;

    return (
        <Box className="ql-snow" sx={{ maxHeight, overflowY: "auto", ...sx }}>
            <Box
                className="ql-editor"
                dangerouslySetInnerHTML={createSafeHtml(html, QUILL_ALLOWED)}
                sx={{
                    p: "0 !important",
                    border: "none !important",
                    overflow: "visible",
                    minHeight: "auto !important",
                    "& p": { mb: 0.5 },
                    "& h1, & h2, & h3": { mt: 1.5, mb: 0.5 },
                    "& blockquote": { my: 1 },
                    "& p:empty, & p:has(br:only-child)": { mb: 1 },
                    "& ol": {
                        listStyleType: "decimal",
                        pl: 3,
                    },
                    "& ul": {
                        listStyleType: "disc",
                        pl: 3,
                    },
                    "& ol > li, & ul > li": {
                        listStyleType: "inherit !important",
                    },
                    "& ol li::before, & ul li::before": {
                        display: "none",
                    },
                }}
            />
        </Box>
    );
};

DmsRichTextViewer.propTypes = {
    html: PropTypes.string,
    maxHeight: PropTypes.number,
    sx: PropTypes.object,
};
